<div class="card-wrapper">
  <div #cardShape class="shape" [ngClass]="getCardCssClasses()"></div>
  <div #content class="card__content" [ngClass]="getCardCssClasses()"
    [attr.tappable]="foldable && !expanded ? '' : null" [attr.expanded]="expanded ? '' : null"
    [attr.foldable]="foldable ? '' : null" (click)="foldable==true && !expanded ? onHeaderClicked($event) : ''">
    @if (foldable) {
      <div class="card__header" #headerTop
        (click)="foldable==true && expanded ? onHeaderClicked($event) : ''"
        [attr.tappable]="foldable==true && expanded ? '' : null"
        [ngClass]="{ expanded : expanded, highlighted : highlighted }">
        <div class="card__header-left">
          <ng-container *ngTemplateOutlet="cardTitleTemplate"></ng-container>
        </div>
        <!-- the whole column is left out when the expanded arrow is hidden, so the title takes its space -->
        @if (!(expanded && hideFoldIconWhenExpanded)) {
          <div class="card__header-right">
            <div class="card__header-fold-icon">
              @if (!expanded) {
                <cs-icon [name]="collapsedFoldIcon"></cs-icon>
              }
              @if (expanded) {
                <cs-icon name="arrow-dropup"></cs-icon>
              }
            </div>
          </div>
        }
      </div>
    }

    <div class="card__body" [ngClass]="{ expanded: expanded, foldable: foldable }" #cardBody>
      <!-- Collapsed view (when foldable and not expanded) -->
      @if (foldable) {
        <div [ngClass]="{ visible: !expanded && !loading }"
          class="card__body-collapsed-expander">
          <div class="card__body-collapsed" #bodyCollapsed>
            <!-- User can place collapsed content here using ng-content -->
            <ng-content select="[collapsed]"></ng-content>
          </div>
        </div>
      }

      <!-- Expanded view (when foldable and expanded) -->
      @if (foldable) {
        <div [ngClass]="{ visible: expanded }"
          class="card__body-expanded-expander">
          <div class="card__body-expanded" #bodyExpanded>
            @if (loadingInternal) {
              <div class="content-spinner">
                <cs-spinner></cs-spinner>
              </div>
            }
            @if (!loadingInternal) {
              <!-- User can place expanded content here using ng-content -->
              <ng-content select="[expanded]"></ng-content>
            }
          </div>
        </div>
      }

      <!-- Plain view (when not foldable) -->
      @if (!foldable) {
        <div class="card__body-general" #bodyPlain (click)="onPlainViewClicked($event)">
          <ng-container *ngTemplateOutlet="cardTitleTemplate"></ng-container>
          <ng-content select="cs-card-header"></ng-content>
          @if (!loadingInternal) {
            <ng-content select="cs-card-content"></ng-content>
          }
          @if (!loadingInternal) {
            <ng-content></ng-content>
          }
          @if (loadingInternal) {
            <div class="content-spinner">
              <cs-spinner></cs-spinner>
            </div>
          }
        </div>
      }
    </div>

    <ng-template #cardTitleTemplate>
      <ng-content select="cs-card-title"></ng-content>
    </ng-template>
  </div>
</div>